import React, { useContext, useEffect } from 'react';
import { CriticalIcon, TitleText } from '@paypalcorp/pp-react';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import { getLocalizedString, WorldReadyProps } from '@client/utils/localeHelper';
import { recordImpression } from '@common/analytics';
import styles from './styles';

const NotFound = () => {
  const worldReady = useContext<WorldReadyProps>(WorldReadyContext);

  useEffect(() => {
    recordImpression({
      eventName: 'not_found_shown',
      pageName: 'not_found'
    });
  }, []);

  return (
    <div css={styles.containerStyles}>
      <div css={styles.iconContainerStyles}>
        <CriticalIcon color="sysColorErrorMain" />
      </div>
      <TitleText>{getLocalizedString(worldReady, 'error.text.default')}</TitleText>
    </div>
  );
};

export default NotFound;
